import { Link, Text } from '@farmersdog/corgi-x';

import styles from './LinkItems.css';
import { navigationLinks } from './navigationLinks';
import { useContactLinks } from './useContactLinks';

export function NavigationLinksList() {
  return (
    <ul className={styles.list}>
      {navigationLinks.map((link, index) => {
        const { label, ...linkProps } = link;

        return (
          <li className={styles.item} key={index}>
            <Text as="span" variant="heading-20">
              <Link baseColor="white" {...linkProps}>
                {label}
              </Link>
            </Text>
          </li>
        );
      })}
    </ul>
  );
}

export function ContactLinksList() {
  const contactLinks = useContactLinks();

  return (
    <ul className={styles.list}>
      {contactLinks.map((link, index) => {
        const { label, icon: Icon, ...linkProps } = link;

        return (
          <li className={styles.item} key={index}>
            <Text as="span" variant="heading-20">
              <Link baseColor="white" {...linkProps}>
                <Icon className={styles.icon} /> {label}
              </Link>
            </Text>
          </li>
        );
      })}
    </ul>
  );
}
